import { Controller } from '@hotwired/stimulus'
import { on, off, emit } from '../lib/events'

export default class extends Controller {
  static values = {
    name: String,
    zIndex: Number,
    backgroundColor: String,
    showOnLoad: { type: Boolean, default: false },
    turbo: { type: Boolean, default: false },
  }

  connect = () => {
    if (this.element.parentNode !== document.body) {
      document.body.appendChild(this.element)
    }
    on(`open${this.nameValue}Modal`, this.openModal)
    on(`close${this.nameValue}Modal`, this.closeModal)
    this.element.addEventListener('click', this.checkClick)
    document.removeEventListener('keydown', this.handleEscKey)
    document.addEventListener('keydown', this.handleEscKey)

    if (this.showOnLoadValue) {
      this.openModal()
    }
  }

  disconnect = () => {
    off(`open${this.nameValue}Modal`, this.openModal)
    off(`close${this.nameValue}Modal`, this.closeModal)
    document.removeEventListener('keydown', this.handleEscKey)

    // Clean up global state
    window.ModalManager.markAsClosed(this.nameValue)
  }

  openModal = () => {
    // Check global state first
    if (!window.ModalManager.canOpen(this.nameValue)) {
      return
    }

    // Start the operation
    if (!window.ModalManager.startOperation('open', this.nameValue)) {
      return // Another open operation in progress
    }

    try {
      if (this.element.style.display === 'flex') {
        return
      }

      if (this.element.style.display === 'none') {
        this.setModal()
        window.ModalManager.markAsOpen(this.nameValue)
      }
    }
    finally {
      window.ModalManager.finishOperation('open', this.nameValue)
    }
  }

  closeModal = () => {
    if (!window.ModalManager.startOperation('close', this.nameValue)) {
      return // Close already in progress
    }

    try {
      if (this.turboValue) {
        this.closeTurboModal()
      }
      else {
        this.showOnLoadValue = false
        this.element.style.display = 'none'
        emit(`${this.nameValue}ModalClosed`, { bubbles: true })
      }

      window.ModalManager.markAsClosed(this.nameValue)
    }
    finally {
      window.ModalManager.finishOperation('close', this.nameValue)
    }
  }

  // Rest of your methods remain the same...
  delayCloseModal = () => {
    setTimeout(() => {
      this.closeModal()
    }, 500)
  }

  closeTurboModal = () => {
    this.element.parentNode.removeAttribute('src')
    this.element.remove()
  }

  checkClick = (event) => {
    if (event.target === this.element) {
      this.closeModal()
    }
  }

  setModal = () => {
    Object.assign(this.element.style, {
      backgroundColor: this.backgroundColorValue,
      width: '100vw',
      maxWidth: '100%',
      height: '100%',
      maxHeight: '100%',
      zIndex: this.zIndexValue,
      left: '0',
      top: '0',
      position: 'fixed',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    })
  }

  handleEscKey = (event) => {
    if (event.key === 'Escape') {
      this.closeModal()
    }
  }
}
